import { 
    userLoggedIn,
} from './cookies.js'

export function quiz() {
    document.addEventListener('DOMContentLoaded', function() {
        const authTitle = document.querySelector('.commercial-section__table-block__auth-button');
        if(userLoggedIn()) {
            authTitle.style.display = 'none';
        } else {
            authTitle.style.display = null;
        }


        let quizData = {
            executorType: '',
            materials: [],
            purchaseTiming: ''
        };

        function initQuiz() {
            const urlParams = new URLSearchParams(window.location.search);
            const categoryIdsParam = urlParams.get('category_id');
            const categoryIds = categoryIdsParam ? categoryIdsParam.split(',') : [];
            
            if (categoryIds.length > 0) {
                showStep(4);
                
                restoreSelectedMaterials(categoryIds);
                
                updateCsvLink(categoryIds[0]);
                calculateTotals();
            } else {
                const steps = document.querySelectorAll('.step');
                steps.forEach((step, index) => {
                    if (index !== 0) {
                        step.style.display = 'none';
                    }
                });
            }

            initInputHandlers();
            initNavigationHandlers();
            
            // Инициализация состояния "Выбрать все" для всех категорий
            initSelectAllStates();
        }

        function initSelectAllStates() {
            const categories = new Set();
            document.querySelectorAll('input[name="materials"]').forEach(checkbox => {
                categories.add(checkbox.dataset.category);
            });
            
            categories.forEach(categoryId => {
                updateSelectAllState(categoryId);
            });
        }

        function calculateTotals() {
            let totalDiscount = 0;
            let totalRegular = 0;
            let totalDifference = 0;
            
            const rows = document.querySelectorAll('#products-table-body tr');
            rows.forEach(row => {
                const cells = row.querySelectorAll('td');
                if (cells.length >= 7) {
                    const discountPrice = parseFloat(cells[4].textContent.replace(/\s/g, '').replace(',', '.')) || 0;
                    const regularPrice = parseFloat(cells[5].textContent.replace(/\s/g, '').replace(',', '.')) || 0;
                    const differencePrice = parseFloat(cells[6].textContent.replace(/\s/g, '').replace(',', '.')) || 0;
                    
                    totalDiscount += discountPrice;
                    totalRegular += regularPrice;
                    totalDifference += differencePrice;
                }
            });
            
            document.getElementById('total-discount').textContent = Number(totalDiscount).toFixed(2) + ' ₽';
            document.getElementById('total-regular').textContent = Number(totalRegular).toFixed(2) + ' ₽';
            document.getElementById('total-difference').textContent = Number(totalDifference).toFixed(2) + ' ₽';
        }

        function restoreSelectedMaterials(categoryIds) {
            const processedCategories = new Set();
            
            document.querySelectorAll('input[name="materials"]').forEach(checkbox => {
                if (categoryIds.includes(checkbox.value)) {
                    checkbox.checked = true;
                    processedCategories.add(checkbox.dataset.category);
                }
            });
            
            // Обновляем состояние "Выбрать все" для всех категорий
            processedCategories.forEach(categoryId => {
                updateSelectAllState(categoryId);
            });
            
            updateMaterialsSelection();
        }

        function initInputHandlers() {
            document.querySelectorAll('input[name="executor_type"]').forEach(radio => {
                radio.addEventListener('change', function() {
                    quizData.executorType = this.value;
                    updateNextButtonState(1);
                });
            });

            document.querySelectorAll('input[name="materials"]').forEach(checkbox => {
                checkbox.addEventListener('change', function() {
                    updateMaterialsSelection();
                    updateSelectAllState(this.dataset.category);
                    updateNextButtonState(2);
                });
            });

            document.querySelectorAll('input[name="purchase_method"]').forEach(radio => {
                radio.addEventListener('change', function() {
                    quizData.purchaseTiming = this.value;
                    updateNextButtonState(3);
                });
            });

            // Обработчик для чекбокса "Выбрать все"
            document.querySelectorAll('.select-all-checkbox').forEach(selectAllCheckbox => {
                selectAllCheckbox.addEventListener('change', function() {
                    const categoryId = this.dataset.category;
                    const materialCheckboxes = document.querySelectorAll(
                        `input[name="materials"][data-category="${categoryId}"]`
                    );
                    
                    materialCheckboxes.forEach(checkbox => {
                        checkbox.checked = this.checked;
                    });
                    
                    updateMaterialsSelection();
                    updateNextButtonState(2);
                });
            });
        }

        function updateMaterialsSelection() {
            quizData.materials = [];
            document.querySelectorAll('input[name="materials"]:checked').forEach(checkbox => {
                quizData.materials.push(checkbox.value);
            });
        }

        function updateSelectAllState(categoryId) {
            const materialCheckboxes = document.querySelectorAll(
                `input[name="materials"][data-category="${categoryId}"]`
            );
            const selectAllCheckbox = document.querySelector(
                `.select-all-checkbox[data-category="${categoryId}"]`
            );
            
            if (!selectAllCheckbox || materialCheckboxes.length === 0) {
                return;
            }
            
            const allChecked = Array.from(materialCheckboxes).every(checkbox => checkbox.checked);
            const someChecked = Array.from(materialCheckboxes).some(checkbox => checkbox.checked);
            
            selectAllCheckbox.checked = allChecked;
            selectAllCheckbox.indeterminate = someChecked && !allChecked;
        }

        function updateNextButtonState(step) {
            const nextButton = document.querySelector(`.step[data-step="${step}"] .next-step`);
            let isEnabled = false;

            switch(step) {
                case 1:
                    isEnabled = quizData.executorType !== '';
                    break;
                case 2:
                    isEnabled = quizData.materials.length > 0;
                    break;
                case 3:
                    isEnabled = quizData.purchaseTiming !== '';
                    break;
            }

            nextButton.disabled = !isEnabled;
        }

        function setCookie(name, value, days) {
            let expires = "";
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/";
        }

        function saveQuizData() {
            setCookie("quizData", JSON.stringify(quizData), 7);
            console.log(JSON.stringify(quizData))
        }

        function initNavigationHandlers() {
            document.querySelectorAll('.next-step').forEach(button => {
                button.addEventListener('click', function() {
                    window.scrollTo(0, 0);
                    const currentStep = this.closest('.step');
                    const nextStepNumber = parseInt(currentStep.dataset.step) + 1;
                    
                    if (nextStepNumber === 4) {
                        saveQuizData();
                        updateUrlWithCategoryParams();
                        window.location.reload();
                        return;
                    }
                    
                    showStep(nextStepNumber);
                });
            });

            document.querySelectorAll('.prev-step').forEach(button => {
                button.addEventListener('click', function() {
                    window.scrollTo(0, 0);
                    const currentStep = this.closest('.step');
                    const prevStepNumber = parseInt(currentStep.dataset.step) - 1;
                    
                    if (parseInt(currentStep.dataset.step) === 4) {
                        removeCategoryParamsFromUrl();
                        window.location.reload();
                        return;
                    }
                    
                    showStep(prevStepNumber);
                });
            });
        }

        function updateUrlWithCategoryParams() {
            const selectedCategories = Array.from(document.querySelectorAll('input[name="materials"]:checked'))
                .map(checkbox => checkbox.value);
            
            if (selectedCategories.length === 0) {
                return;
            }

            const url = new URL(window.location);
            
            url.searchParams.delete('category_id');
            
            if (selectedCategories.length > 0) {
                url.searchParams.set('category_id', selectedCategories.join(','));
            }
            
            window.history.pushState({}, '', url);
            
            updateCsvLink(selectedCategories[0]);
        }

        function removeCategoryParamsFromUrl() {
            const url = new URL(window.location);
            url.searchParams.delete('category_id');
            window.history.pushState({}, '', url);
        }

        function updateCsvLink(categoryId) {
            const csvLink = document.querySelector('.commercial-section__type-block__button-block .button_accent');
            if (csvLink) {
                csvLink.href = `/commercial-offer/export/?category_id=${categoryId}&format=csv`;
            }
        }

        function showStep(stepNumber) {
            document.querySelectorAll('.step').forEach(step => {
                step.style.display = 'none';
            });
            
            const targetStep = document.querySelector(`.step[data-step="${stepNumber}"]`);
            if (targetStep) {
                targetStep.style.display = null;
            }
        }

        initQuiz();
    });
}